// Lib
import React, { ReactElement } from 'react';

// Components
import SheetContainer, { Content, Overlay, Sheet } from '../../mobile/structural/sheet';
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';

// Types
import { SheetId } from '../../mobile/structural/sheet/sheetTypes';
import ReportContentForm from './ReportContentForm';

// Styles
import './ReportContentSheet.scss';

const ReportContentSheet = (): ReactElement => {
    const sheetProps = useSheet(SheetId.ReportContent);

    return (
        <SheetContainer className="ReportContentSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <ReportContentForm close={sheetProps.dispatchCloseSheet} />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default ReportContentSheet;
